import * as React from "react";
import { Button, Grid, Link, Typography } from "@mui/material";
import { AppBody } from "../AppBody";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { appHeaderTitle } from "../../common/services/Utilities";
import HelpButton from "../HelpContent/HelpButton";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as StandardComparison } from "../../common/assets/images/StandardComparisons.svg";
import { ReactComponent as CustomizedComparison } from "../../common/assets/images/CustomizedComparisons.svg";
import { ReactComponent as SavedPeerGroups } from "../../common/assets/images/SavePeersReports.svg";
import { ReactComponent as Financials } from "../../common/assets/images/icon_FinancialR_static.svg";
import { ReactComponent as FinancialsFocused } from "../../common/assets/images/icon_FinancialR_focus.svg";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";

const useStyle = makeStyles(theme => ({
  button: {
    "display": "block",
    "height": 330,
    "margin": "0 auto",
    "&:hover, &.Mui-focusVisible": {
      "backgroundColor": "transparent",
      "& .Rectangle-ManageSPG-Copy, & #Path-3": {
        stroke: "#ffffff",
        fill: theme.palette.primary.main,
      },
      "& #Rectangle": { stroke: "#a58922", fill: theme.palette.primary.main },
      "& #Group-4, & #arrow": { fill: "#ffffff" },
      "& #Group-6, & #Rectangle-ManageSPG": {
        fill: "#ffffff",
      },
    },
  },
}));

export default function FinancialReporting() {
  const classes = useStyle();
  const history = useHistory();
  const [focusFR, setFocusFR] = React.useState(false);

  const financialsIcon =
    focusFR === true ? <FinancialsFocused /> : <Financials />;

  useInitialPageLoad("financials");

  const introParagraph = (
    <>
      {appHeaderTitle("financialReport")}
      <Typography variant="body2" id="financial-reporting-description">
        Create comprehensive financial reports of single institutions and peer
        groups using quarterly data since 1992. Use our predefined options of
        reports and standard peer groups, or create your own library of reusable
        customized tools to research the subjects and data tailored to your
        interests (saving custom content requires logging in with a login.gov
        account.)
      </Typography>

      <Typography variant="body2" id="financial-reporting-tutorials">
        If you need assistance, please see the{" "}
        <RouterLink to={"/help?helpTopic=tutorials"}>Help Section</RouterLink>{" "}
        for tutorials to get you started.
      </Typography>

      <Typography variant="body2" id="peer-group-feedback-link">
        Provide{" "}
        <Link
          href={
            "https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=FinRegData"
          }
        >
          feedback or submit a question
        </Link>{" "}
        about this page.
      </Typography>
    </>
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={11}>
          <Breadcrumbs currentPageBreadCrumbTitle="Financial Reporting" />
        </Grid>
        <Grid item xs={1}>
          <HelpButton />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <AppBody introText={introParagraph} login>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Button
              id="financialReporting"
              style={{
                display: "block",
                margin: "0 auto",
                height: 330,
                backgroundColor: "transparent",
              }}
              onMouseEnter={() => setFocusFR(true)}
              onMouseLeave={() => setFocusFR(false)}
              onClick={() =>
                history.push(`${AppUrl("FinancialReporting")}/report`)
              }
            >
              {financialsIcon}
              <Typography variant="h2">
                Financial/Regulatory<br></br>Search & Reporting
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              id="pgcStandard"
              style={{ marginTop: 14 }}
              className={classes.button}
              onClick={() => history.push(`${AppUrl("PeerGroup")}/standard`)}
            >
              <StandardComparison />
              <Typography variant="h2">
                Standard<br></br>Comparisons
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              id="pgcCustomized"
              className={classes.button}
              onClick={() =>
                history.push({
                  pathname: `${AppUrl("PeerGroup")}/customized`,
                  state: {
                    url: AppUrl("PeerGroup") + window.location.search,
                  },
                })
              }
            >
              <CustomizedComparison />
              <Typography variant="h2">
                Customized<br></br>Comparisons
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              id="pgcManageSavedPeerGroups"
              className={classes.button}
              onClick={() =>
                history.push({
                  history: "FR",
                  pathname: `${AppUrl("PeerGroup")}/manage`,
                  state: {
                    url: AppUrl("PeerGroup") + window.location.search,
                  },
                })
              }
            >
              <SavedPeerGroups />
              <Typography variant="h2">
                Manage Your Saved<br></br>Custom Content
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </AppBody>
    </>
  );
}
